import { render, staticRenderFns } from "./DepositInfo.vue?vue&type=template&id=037d7492&"
import script from "./DepositInfo.vue?vue&type=script&lang=js&"
export * from "./DepositInfo.vue?vue&type=script&lang=js&"
import style0 from "./DepositInfo.vue?vue&type=style&index=0&id=037d7492&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports